"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimension = void 0;
const account_1 = require("./account");
const campaign_1 = require("./campaign");
const country_1 = require("./country");
const device_1 = require("./device");
const domain_1 = require("./domain");
const medium_1 = require("./medium");
const platform_1 = require("./platform");
const source_1 = require("./source");
exports.dimension = {
    account: {
        name: 'Accounts',
        query: account_1.account,
    },
    campaign: {
        name: 'Campaigns',
        query: campaign_1.campaign,
    },
    country: {
        name: 'Countries',
        query: country_1.country,
    },
    device: {
        name: 'Devices',
        query: device_1.device,
    },
    domain: {
        name: 'Domains',
        query: domain_1.domain,
    },
    medium: {
        name: 'Medium',
        query: medium_1.medium,
    },
    platform: {
        name: 'Platform',
        query: platform_1.platform,
    },
    source: {
        name: 'Sources',
        query: source_1.source,
    },
};
//# sourceMappingURL=index.js.map